import { Plus, Trash2 } from 'lucide-react'

// Editor da tabela "comissão de venda por quantidade de animais".
// `faixas`: [{ qtd_min, qtd_max: '' | number, percentual: '' | number }] — faixas contíguas a partir de 1;
// só o "de" da 1ª é fixo (1); o "de" das demais é sempre (até anterior + 1); a última pode ficar sem teto.
export default function FaixasQtdVendaEditor({ faixas, onChange }) {
  const recalcular = (lista) => {
    let proximo = 1
    return lista.map((f, i) => {
      const item = { ...f, qtd_min: proximo }
      const max = parseInt(f.qtd_max, 10)
      proximo = Number.isFinite(max) ? max + 1 : proximo
      return item
    })
  }

  const atualizar = (i, campo, valor) =>
    onChange(recalcular(faixas.map((f, idx) => (idx === i ? { ...f, [campo]: valor } : f))))

  const adicionar = () => {
    const ultima = faixas[faixas.length - 1]
    const max = parseInt(ultima?.qtd_max, 10)
    if (!Number.isFinite(max)) return // última faixa sem teto: preencha o "até" antes
    onChange(recalcular([...faixas, { qtd_min: max + 1, qtd_max: '', percentual: '' }]))
  }

  const remover = (i) => onChange(recalcular(faixas.filter((_, idx) => idx !== i)))

  const podeAdicionar = Number.isFinite(parseInt(faixas[faixas.length - 1]?.qtd_max, 10))

  return (
    <div className="border border-amber-200 rounded-lg p-4 bg-amber-50">
      <h4 className="font-medium text-amber-800 mb-1">🐂 Comissão de Venda por Quantidade de Animais</h4>
      <p className="text-xs text-gray-600 mb-3">
        A comissão de venda do lote depende da quantidade de cabeças. Deixe o "até" da última faixa vazio para "mais de N".
      </p>
      <div className="space-y-2">
        {faixas.map((f, i) => (
          <div key={i} className="grid grid-cols-[1fr_1fr_1fr_auto] gap-2 items-end">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">De (cabeças)</label>
              <input type="number" value={f.qtd_min} readOnly className="input-rematei text-sm bg-gray-100" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Até (cabeças)</label>
              <input
                type="number" min={f.qtd_min}
                value={f.qtd_max}
                onChange={(e) => atualizar(i, 'qtd_max', e.target.value)}
                className="input-rematei text-sm"
                placeholder={i === faixas.length - 1 ? 'sem limite' : ''}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Comissão venda (%)</label>
              <input
                type="number" step="0.01" min="0" max="100"
                value={f.percentual}
                onChange={(e) => atualizar(i, 'percentual', e.target.value)}
                className="input-rematei text-sm"
                placeholder="5.00"
              />
            </div>
            <button
              type="button" onClick={() => remover(i)} disabled={faixas.length === 1}
              className="p-2 text-red-500 hover:text-red-700 disabled:opacity-30" title="Remover faixa"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button" onClick={adicionar} disabled={!podeAdicionar}
        className="mt-3 flex items-center gap-1 text-sm text-amber-700 hover:text-amber-900 disabled:opacity-40"
        title={podeAdicionar ? '' : 'Preencha o "até" da última faixa para adicionar outra'}
      >
        <Plus className="w-4 h-4" /> Adicionar faixa
      </button>
    </div>
  )
}
